var map = {
	"./3D Text.ico": "cd28",
	"./3D computer.ico": "0c22",
	"./Apple.ico": "8398",
	"./Beizer.ico": "586f",
	"./Book 2.ico": "27fd",
	"./Book 4.ico": "1297",
	"./Book Disc.ico": "fd45",
	"./Briefcase.ico": "990a",
	"./Bunch of Keys.ico": "037b",
	"./Calculator.ico": "aecb",
	"./Chat.ico": "b4f3",
	"./Chemistry with phone.ico": "be97",
	"./Cine-film roll.ico": "8c4e",
	"./Cine-film with music.ico": "a362",
	"./Cine-film.ico": "8350",
	"./Clipboard with phone.ico": "302e",
	"./Computer Input.ico": "0a28",
	"./Computer are Earth.ico": "d368",
	"./Computer with phone.ico": "ec9d",
	"./Conference table.ico": "a357",
	"./Config program.ico": "6cfd",
	"./Config sheet.ico": "e176",
	"./Devices.ico": "47c2",
	"./Disc Drive.ico": "4e93",
	"./Diskette Drive with Diskette.ico": "5e82",
	"./Diskette.ico": "29a9",
	"./Document with Earth.ico": "e718",
	"./Drawing green picture.ico": "6fd3",
	"./Drive Graph.ico": "0183",
	"./Earth (4 colors).ico": "2a03",
	"./Earth Help Program.ico": "d621",
	"./Fax.ico": "5959",
	"./Flying Windows.ico": "20f7",
	"./Folder (hi-res).ico": "8ca3",
	"./Help book.ico": "ca9d",
	"./Letter 2.ico": "a2d7",
	"./Letter with phone.ico": "9968",
	"./Letter.ico": "124c",
	"./Letters (3D).ico": "e001",
	"./MSN.ico": "d88d",
	"./Mail Search on Earth.ico": "bc68",
	"./Mail catalog.ico": "ac4e",
	"./Mail.ico": "91be",
	"./MasterCard.ico": "13cf",
	"./Microphone & Cassette.ico": "9fa2",
	"./Microphone.ico": "72eb",
	"./Microsoft with Ball.ico": "3908",
	"./Movie Frame (3-2-1).ico": "ebdf",
	"./Movie frame (in hands).ico": "c210",
	"./Music Disc 2.ico": "e75e",
	"./Music Disc.ico": "ad88",
	"./Night on computer.ico": "3b59",
	"./Notepad writing.ico": "3f96",
	"./Paint.ico": "70dc",
	"./Paintbrish.ico": "c279",
	"./Windows 95 logo.ico": "f0a8",
	"./Windows Disc.ico": "3d7e",
	"./Windows Key (48x48).ico": "fd71",
	"./Windows document.ico": "5260",
	"./Windows logo (without text).ico": "7da8",
	"./apple2.png": "c699",
	"./bio.png": "1942",
	"./donut.png": "4487",
	"./download.png": "6a08",
	"./mail.png": "9f78",
	"./open.png": "4ae6",
	"./opensource.png": "462a",
	"./photos.png": "3fbd",
	"./resume.png": "7eb0",
	"./send.png": "5d8c",
	"./sidebar.png": "9165",
	"./speakers.png": "73ac",
	"./three.png": "9b18",
	"./warning.png": "ebf1",
	"./webos.png": "fadb",
	"./win95.png": "0c67",
	"./win95.svg": "cc3e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1fe5";